import { render } from "./ImagesViewer.vue?vue&type=template&id=23127342&scoped=true"
import script from "./ImagesViewer.vue?vue&type=script&lang=js"
export * from "./ImagesViewer.vue?vue&type=script&lang=js"

import "./ImagesViewer.vue?vue&type=style&index=0&id=23127342&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23127342"]])

export default __exports__